import { useState } from 'react';
import { IconCalendar, IconMusic, IconPiano, IconUser } from '@tabler/icons-react';
import { OnboardingLayout } from '@widgets/layout/ui/onboarding-layout';
import { Instrument } from './instrument';
import { Schedule } from './schedule';
import { TeacherProfile } from './teacher-profile';
import { Appointment } from './appointment';
import { Completion } from './completion';
import { StudentOnboardingFooter } from '@pages/student/onboarding/footer';

export const Onboarding = () => {
	const [currentStep, setCurrentStep] = useState(0);

	const steps = [
		{
			id: 0,
			icon: IconPiano,
			title: 'Инструмент',
			subtitle: 'Укажите инструменты, на которых вы преподаете',
			component: <Instrument setCurrentStep={setCurrentStep} />,
		},
		{
			id: 1,
			icon: IconCalendar,
			title: 'Расписание',
			subtitle: 'Выберите удобное для вас расписание',
			component: <Schedule setCurrentStep={setCurrentStep} />,
		},
		{
			id: 2,
			icon: IconUser,
			title: 'Профиль',
			subtitle: 'Так ученики видят вашу карточку',
			component: <TeacherProfile setCurrentStep={setCurrentStep} />,
		},
		{
			id: 3,
			icon: IconMusic,
			title: 'Занятия',
			subtitle: 'Как проходит урок и конференция',
			component: <Appointment setCurrentStep={setCurrentStep} />,
		},
		{
			id: 4,
			hidden: true,
			component: <Completion />,
		},
	];

	return (
		<OnboardingLayout
			steps={steps}
			currentStep={currentStep}
			onStepChange={setCurrentStep}
			showStepProgression
			footer={<StudentOnboardingFooter />}
		>
			{steps[currentStep]?.component}
		</OnboardingLayout>
	);
};
